import * as ReactDOM from "react-dom";
import * as React from "react";

const { Component } = React;

import { BrowserRouter, Route, NavLink, Routes, useNavigate, useLocation } from "react-router-dom";

import { GetCurrentLoggedInUser, Account } from "./account/AccountStore";

import HomeIndex from "./home/HomeIndex";
import Profile from "./account/Profile";
import ProfileData from "./account/ProfileData";
import ProfileMultiFactor from "./account/ProfileMultiFactor";
import ProfileSecurity from "./account/ProfileSecurity";

import Loader from "./general/Loader";
import OrganizationIndex, { Tabs } from "./organizations/Index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UsersIndex } from "./users/Index";
import { AdminsIndex } from "./admins/AdminsIndex";
import { GetContext } from "./general/ApplicationContext";
import { Organization } from "./users/UserStore";
import { GroupsIndex } from "./groups/Index";
import GuidesIndex from "./guides/GuidesIndex";
import GuidesCreate from "./guides/GuidesCreate";
import GuidesEdit from "./guides/GuidesEdit";

const OrganizationIndexWrapper = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return <OrganizationIndex navigate={navigate} location={location} />;
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/*" element={<Home></Home>} />
            </Routes>
        </BrowserRouter>
    );
}

const Home = () => {
    const [user, setUser] = React.useState(new Account({}));
    const [loading, setLoading] = React.useState(true);
    const location = useLocation();
    const [organization, setOrganization] = React.useState({} as Organization);

    const [logoImage, setLogoImage] = React.useState("/static/branding/images/logo");

    React.useEffect(() => {
        //@ts-ignore
        document.querySelector("#sidenavButton").addEventListener("click", () => {
            //@ts-ignore
            document.querySelector("#sidenav").classList.toggle("isOpen");
        });

        if (window.screen.width < 450) {
            //@ts-ignore
            document.querySelector("#sidenav").classList.toggle("isOpen");
        }

        GetCurrentLoggedInUser()
            .then((user) => {
                setUser(user);
                setLoading(false);
            })
            .catch(() => {
                window.location.href = "/Account/Login";
            });

        GetContext((ctx) => {
            setLogoImage("/static/branding/images/logo?brandingId=" + (ctx.currentOrganization?.id || ""));
            setOrganization(ctx.currentOrganization);
        });
    }, []);

    return (
        <div>
            <div className="wrapper">
                <div id="sidenav" className="sidebar isOpen">
                    <h2 style={{ padding: "1.2rem 0" }}>
                        <a className="d-flex" href="/">
                            <img src={logoImage} alt={organization.name} className="img mx-auto" style={{ height: "25px", maxWidth: "180px" }} />
                        </a>
                    </h2>
                    <h3>
                        <a className="d-flex" href="/">
                            <img src={logoImage} alt={organization.name} className="img mx-auto" style={{ height: "45px", maxWidth: "180px" }} />
                        </a>
                    </h3>
                    <ul className="sidenav">
                        {user && (
                            <>
                                {user.isAdmin() && (
                                    <>
                                        <li>
                                            <NavLink to="/organizations">
                                                <FontAwesomeIcon icon={["fad", "building"]}></FontAwesomeIcon> Organizations
                                            </NavLink>
                                            {location.pathname.startsWith("/organizations") && (
                                                <ul className="sidenav-sub">
                                                    {Tabs.map((t) => (
                                                        <li key={t.route}>
                                                            <NavLink to={t.route}>
                                                                {/* @ts-ignore */}
                                                                <FontAwesomeIcon icon={t.icon}></FontAwesomeIcon> {t.name}
                                                            </NavLink>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                        <li>
                                            <NavLink to="/users">
                                                <FontAwesomeIcon icon={["fad", "users"]}></FontAwesomeIcon> Users
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/groups">
                                                <FontAwesomeIcon icon={["fad", "users-cog"]}></FontAwesomeIcon> Groups
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/admins">
                                                <FontAwesomeIcon icon={["fad", "user-gear"]}></FontAwesomeIcon> Admins
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/guides">
                                                <FontAwesomeIcon icon={["fad", "book"]}></FontAwesomeIcon> Guides
                                            </NavLink>
                                        </li>
                                    </>
                                )}

                                {!user.isAdmin() && (
                                    <>
                                        {user.hasPermission("manageOrganizations") && (
                                            <li>
                                                <NavLink to="/organizations">
                                                    <FontAwesomeIcon icon={["fad", "building"]}></FontAwesomeIcon> Organizations
                                                </NavLink>
                                                <ul className="sidenav">
                                                    {Tabs.filter((t) => user.hasPermission(t.permission)).map((t) => (
                                                        <li key={t.route}>
                                                            <NavLink to={t.route}>
                                                                {/* @ts-ignore */}
                                                                <FontAwesomeIcon icon={t.icon}></FontAwesomeIcon> {t.name}
                                                            </NavLink>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        )}
                                        {user.hasPermission("searchUsers") && (
                                            <li>
                                                <NavLink to="/users">
                                                    <FontAwesomeIcon icon={["fad", "users"]}></FontAwesomeIcon> Users
                                                </NavLink>
                                            </li>
                                        )}
                                        {user.hasPermission("manageOrganizationGroups") && (
                                            <li>
                                                <NavLink to="/groups">
                                                    <FontAwesomeIcon icon={["fad", "users-cog"]}></FontAwesomeIcon> Groups
                                                </NavLink>
                                            </li>
                                        )}
                                    </>
                                )}
                                <li>
                                    <a href="/Account/LogOut">
                                        <FontAwesomeIcon icon={["fad", "lock"]}></FontAwesomeIcon> Sign out
                                    </a>
                                </li>
                            </>
                        )}
                        {!user && (
                            <>
                                <li>
                                    <a href="/Account/LogIn">
                                        <FontAwesomeIcon icon={["fad", "unlock"]}></FontAwesomeIcon> Sign in
                                    </a>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
                <div id="sidenavContent" className="content">
                    <a id="sidenavButton" className="sidenav-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <line x1="0" y1="30" x2="70" y2="30"></line>
                            <line x1="0" y1="50" x2="75" y2="50"></line>
                            <line x1="0" y1="70" x2="70" y2="70"></line>
                        </svg>
                    </a>
                    {loading && <Loader></Loader>}
                    {!loading && (
                        <>
                            {user && user.id && (
                                <div>
                                    <Routes>
                                        <Route path="/profile/security" element={<ProfileSecurity></ProfileSecurity>} />
                                        <Route path="/profile/mfa" element={<ProfileMultiFactor></ProfileMultiFactor>} />
                                        <Route path="/profile/data" element={<ProfileData></ProfileData>} />
                                        <Route path="/profile" element={<Profile></Profile>} />
                                        <Route path="/organizations/*" element={<OrganizationIndexWrapper></OrganizationIndexWrapper>} />
                                        <Route path="/users" element={<UsersIndex></UsersIndex>} />
                                        <Route path="/groups" element={<GroupsIndex></GroupsIndex>} />
                                        <Route path="/admins" element={<AdminsIndex></AdminsIndex>} />
                                        <Route path="/guides" element={<GuidesIndex></GuidesIndex>} />
                                        <Route path="/guides/create" element={<GuidesCreate></GuidesCreate>} />
                                        <Route path="/guides/:id" element={<GuidesEdit></GuidesEdit>} />
                                        <Route path="/" element={<HomeIndex></HomeIndex>} />
                                    </Routes>
                                </div>
                            )}
                            {!user && (
                                <a href="/account/login">
                                    <img className="img-fluid" src="/images/cloud-splash.png" alt="" style={{ display: "block", margin: "auto", marginTop: "10rem" }} />
                                </a>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

ReactDOM.render(React.createElement(App, {}, null), document.getElementById("home"));
